import { BREAKPOINTS } from "@consts/ui";
import useReduxState from "./useReduxState";
type TBreakpointHook = "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl";

export default function useBreakpoint(): {
  windowWidth: number;
  breakpoint: number;
  slug: TBreakpointHook;
  breakpoints: typeof BREAKPOINTS;
} {
  const [{ windowWidth }] = useReduxState((state) => state.ui);
  let slug: TBreakpointHook = "sm";
  let breakpoint: number = BREAKPOINTS.SM;

  if (windowWidth > BREAKPOINTS.SM && windowWidth <= BREAKPOINTS.MD) {
    slug = "md";
    breakpoint = BREAKPOINTS.MD;
  }

  if (windowWidth > BREAKPOINTS.MD && windowWidth <= BREAKPOINTS.LG) {
    slug = "lg";
    breakpoint = BREAKPOINTS.LG;
  }

  if (windowWidth > BREAKPOINTS.LG && windowWidth <= BREAKPOINTS.XL) {
    slug = "xl";
    breakpoint = BREAKPOINTS.XL;
  }

  if (windowWidth > BREAKPOINTS.XL && windowWidth <= BREAKPOINTS.XXL) {
    slug = "xxl";
    breakpoint = BREAKPOINTS.XXL;
  }

  if (windowWidth > BREAKPOINTS.XXL && windowWidth <= BREAKPOINTS._2XXL) {
    slug = "xxxl";
    breakpoint = BREAKPOINTS._2XXL;
  }

  return {
    windowWidth,
    breakpoint,
    slug,
    breakpoints: BREAKPOINTS,
  };
}
